// extracted by mini-css-extract-plugin
module.exports = {"container":"_1ZlPKaitPLEMpQMg1NXZyb","avatar":"_2LdYZkyMkn9Jz8Kq72uwIr"};